import useHover from '@anm/hooks/useHover';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { hostedVideoActions, hostedVideoSelectors } from '../../../../store/modules/hostedVideo';

export const useHostedVideoManifestFetch = (hostId?: string) => {
  const dispatch = useDispatch();
  const { id: fetchedManifestId = '' } = useSelector(hostedVideoSelectors.selectManifest) || {};

  const getManifest = useCallback(() => {
    if (hostId && hostId !== fetchedManifestId) {
      requestAnimationFrame(() => dispatch(hostedVideoActions.getManifest(hostId)));
    }
  }, [hostId, fetchedManifestId]);

  return getManifest;
};

const useHostedVideoManifestFetchOnHover = (hostId?: string) => {
  const [hoverRef, isHovered] = useHover<HTMLDivElement>();
  const getManifest = useHostedVideoManifestFetch(hostId);

  useEffect(() => {
    if (isHovered) getManifest();
  }, [isHovered, hostId]);

  return [hoverRef, isHovered] as const;
};

export default useHostedVideoManifestFetchOnHover;
